import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import { FaCar } from "react-icons/fa";

const InfoVehiculo = ({ vehiculoId }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [vehicleInfo, setVehicleInfo] = useState(null);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!vehiculoId) return;

    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerVehiculos/${vehiculoId}`,
    })
      .then((response) => {
        if (response.data && response.data.length > 0) {
          const vehiculo = response.data[0].v;
          const marca = response.data[0].marca;
          setVehicleInfo({ ...vehiculo, marca }); // unificamos marca con los demás campos
        } else {
          setVehicleInfo(null);
        }
      })
      .catch((error) => {
        console.error("Error al obtener el vehículo:", error);
        setVehicleInfo(null);
      });
  }, [vehiculoId]);

  return (
    <>
      {/* Texto visible en la tabla */}
      <span>
        {vehicleInfo
          ? `${vehicleInfo.marca || "Marca"} - ${vehicleInfo.placa || "Placa"}`
          : "Cargando..."}
      </span>

      <button
        className="btn btn-link p-0 ms-2"
        title="Información detallada del vehículo"
        onClick={handleOpenModal}
      >
        <FaCar size={18} />
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Información del Vehículo"
        ariaHideApp={false}
        style={{
          content: {
            top: "10%",
            left: "10%",
            right: "10%",
            bottom: "10%",
            overflow: "auto",
          },
        }}
      >
        <Container fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between">
                  <h3 className="mb-0">Información del Vehículo</h3>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={closeModal}
                  >
                    Cerrar
                  </button>
                </CardHeader>
                <CardBody>
                  {vehicleInfo ? (
                    <Form>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label>Placa</label>
                            <Input
                              type="text"
                              value={vehicleInfo.placa || ""}
                              readOnly
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label>VIN</label>
                            <Input
                              type="text"
                              value={vehicleInfo.vin || ""}
                              readOnly
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label>Modelo</label>
                            <Input
                              type="text"
                              value={vehicleInfo.modelo || ""}
                              readOnly
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label>Tipo de Vehículo</label>
                            <Input
                              type="text"
                              value={vehicleInfo.tipoVehiculo || ""}
                              readOnly
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label>Marca</label>
                            <Input
                              type="text"
                              value={vehicleInfo.marca || ""}
                              readOnly
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  ) : (
                    <p>No se pudo obtener la información del vehículo.</p>
                  )}
                </CardBody>
              </Card>
            </div>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default InfoVehiculo;
